import {useMemo} from 'react';
import ReactDOM from 'react-dom';

export const PortalTo = (props: {element: string | HTMLElement; children: React.ReactNode}) => {
    const container = useMemo(() => {
        if (props.element instanceof HTMLElement) {
            return props.element;
        } else {
            return document.querySelector(props.element);
        }
    }, [props.element]);

    if (!container) {
        throw new Error(`PortalTo has no container to render to, element is "${props.element}"`);
    }
    return ReactDOM.createPortal(props.children, container);
};

export default PortalTo;
